/**
 * Copyright(c) 2022 Fenix Outdoor International AG.
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of Fenix ("Confidential
 * Information"). You shall not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the contract agreement you entered into with Fenix.
 *
 */
import user from "./UserData";

export const isAuthenticated = () => user.getAuthenticated() === "true";

/**
 * Checking logged in user has any one of accessrights
 * @param {Array} rights
 */
export const hasAccessRights = (rights) => {
  const allowedRightsString = JSON.parse(user.getAccessRights());
  return Array.isArray(allowedRightsString)
    ? rights.every((right) => allowedRightsString.includes(right)) : false;
};

/**
 * Checking logged in user has any one of role
 * @param {Array} roles
 */
export const hasRole = (roles) => roles.some((role) => user.getType() === role);
